export const SET_INITIAL_PROFILE = 'SET_INITIAL_PROFILE';
export const CLEAR_INITIAL_PROFILE = 'CLEAR_INITIAL_PROFILE';

export const SET_INITIAL_POST = 'SET_INITIAL_POST';
export const CLEAR_INITIAL_POST = 'CLEAR_INITIAL_POST';